<app-dialog-header [title]="title"></app-dialog-header>
<mat-dialog-content class="with-footer">
  <div class="body-2" *ngIf="description">{{description}}</div>
  <app-text-input [type]="TextInputType.Email" [label]="'general.api_configure_email_name'" [(value)]="email"></app-text-input>
</mat-dialog-content>
<app-dialog-footer [dialogActions]="dialogActions"></app-dialog-footer>
<ng-template #dialogActions>
  <button mat-button (click)="clearEmail()">{{'general.api_configure_email_button_clear' | translate}}</button>
  <button mat-flat-button color="primary" (click)="saveEmail()" [disabled]="!isValidEmail()">
    {{buttonOk}}
  </button>
</ng-template>
